export const getRefinanceLoanAmount = (
  lookingTo,
  existingLoanBalance,
  amountOfCashOut
) => {
  if (lookingTo === "RefinanceAndCashOut") {
    return Number(existingLoanBalance ?? 0) + Number(amountOfCashOut ?? 0);
  }
  return Number(existingLoanBalance ?? 0);
};
